var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("QR CODE FOR RECEIPT")]),(_vm.token)?_c('img',{attrs:{"src":("https://qrcode.tec-it.com/API/QRCode?data=" + _vm.token),"alt":"QR Code","width":"200","height":"200"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }